import actions from '../../actionTypes';

export default groupId => {
  return {
    type: actions.REMOVE_GROUP,
    groupId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/removeGroup.js